import { reducers as reducersIsotope } from 'isotope-client'

export default {
	...reducersIsotope
}
